import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { data } from "../utils/navbar";
import { Dashboard } from "../utils/dashboard";
import Error from "../component/Error";
import Navbar from "../component/Navbar";
import Sell from "../component/Sell";
import MyPorperties from "../component/MyProperties";
import PrivateRoute from "./PrivateRoute";
import IndivialHouse from "../component/Buy/IndividualHouse";
export const Root = () => {
  return (
    <Routes>
      <Route element={<Navbar />}>
        <Route path="/buy/:id" element={<IndivialHouse />} />
        {data?.map(
          ({ id, pathname, Component, isPrivate }) =>
            !isPrivate && (
              <Route key={id} path={pathname} element={<Component />} />
            )
        )}
        <Route element={<Sell />}>
          {Dashboard?.map(({ id, pathname, Component }) => (
            <Route key={id} path={pathname} element={<Component />} />
          ))}
        </Route>
        <Route
          path="/my-properties"
          element={
            <PrivateRoute>
              <MyPorperties />
            </PrivateRoute>
          }
        />
      </Route>

      <Route path="/" element={<Navigate to="/home" />} />
      <Route path="*" element={<Error />} />
    </Routes>
  );
};
